import { Form } from "."

/**
 * FormGroupError
 */
type Props = React.ComponentProps<"p">
export const FormGroupError: React.FC<Props> = ({ className, ...props }) => {
  return <Form.Error className={cxm("text-red-600 font-light text-xs", className)} {...props} />
}
